import styled from 'styled-components';

export const Box = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  border-radius: 5px;
  padding: 16px 17px;
  margin-bottom: 22px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

export const Title = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.surface.onSurface};

  em {
    font-style: normal;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }
`;

export const ConfigLink = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary.primary};
`;

// Barra de distribuição: hue única com intervalos de 2px entre os segmentos.
// O trabalho dela é mostrar se a soma fecha 100%, não comparar SPEs entre si —
// a identidade de cada uma já está na linha logo abaixo.
export const Track = styled.div`
  display: flex;
  gap: 2px;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 13px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
`;

export const Segment = styled.div<{ $width: number; $over?: boolean }>`
  height: 100%;
  width: ${({ $width }) => $width}%;
  background-color: ${({ theme, $over }) =>
    $over ? theme.colors.danger.danger : theme.colors.primary.primary};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  font-size: 12px;
`;

export const Name = styled.span`
  flex: 1;
  min-width: 0;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const Document = styled.span`
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const Weight = styled.span`
  width: 62px;
  text-align: right;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const Amount = styled.span`
  width: 96px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 13px;
  padding-top: 11px;
  border-top: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  font-size: 12px;
`;

export const Status = styled.span<{ $ok: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: ${({ theme, $ok }) =>
    $ok ? theme.colors.success.success : theme.colors.danger.danger};
`;

export const Total = styled.span`
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const Empty = styled.p`
  font-size: 12px;
  line-height: 1.55;
  margin: 0;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;
